import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, stateActionId, toastSuccess } from "../../../../utils/constants";
import { emailValidator, panNoValidator, tanNoValidator, notMendetoryEmailValidator, pincodeValidator } from '../../../../utils/Validator'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
// import { getStateMasterDetails_action, insertUpdateCityMaster_action } from "../../../../actions/admin_module_action/master_action/hall_master_action";
import { insertCityMaster_action, updateCityMaster_action, getCityMasterList_action } from "../../../../actions/admin_module_action/master_action/city_master_action";
import Footer from "../../../../common_components/Footer";


class StateAU extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            is_add: false,
            is_update: false,
            StateID: '',
            CityID: '',
            countryID: '',
            countryList: [],
            stateList: [],
            cityName: '',
            StateErrMsg: '',
            cityErrMsg: '',
            countryErrMsg: '',
        }

        this.getCityMasterList = this.getCityMasterList.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.insertCityMaster = this.insertCityMaster.bind(this)
        this.updateCityMaster = this.updateCityMaster.bind(this)
        this.onNextClick = this.onNextClick.bind(this)
        this.getFillList = this.getFillList.bind(this)

    }

    componentDidMount() {
        this.setState({
            is_add: this.props.location.state != null && this.props.location.state.is_add != null ? this.props.location.state.is_add : false,
            is_update: this.props.location.state != null && this.props.location.state.is_update != null ? this.props.location.state.is_update : false,
            CityID: this.props.location.state != null && this.props.location.state.CityID != null ? this.props.location.state.CityID : '',
        })

        this.getFillList(countryActionId, '', '', '', '', '').then(() => {
            this.getFillList(stateActionId, '', '', '', '', '').then(() => {
                this.getCityMasterList()
            })
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                            this.setState({
                                countryList: data.data
                            })
                            resolve(true)
                        } else if (actionID === stateActionId) {
                            console.log("country data", data.data)
                            // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                            this.setState({
                                stateList: data.data
                            })
                            resolve(true)
                        }
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getCityMasterList() {
        this.setState({ isLoading: true })
        const { countryID, stateName, StateID, CityID, Status, CityName } = this.state
        console.log('CountryID', countryID)
        this.props.getCityMasterList_action(countryID, StateID, CityName, null)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    data.data[0].length > 0 && data.data[0].map((item) => {
                        if (item.CityID == CityID) {
                            this.setState({ cityName: item.CityName, countryID: item.CountryID, StateID: item.StateID })
                        }
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onPreviousClick() {
        this.props.navigate('/cityMasterList',)
    }
    insertCityMaster() {
        const { isLoading, exhibitionID, cityName, StateID, CityID, countryID, hallName, StateErrMsg, is_update, StateNo, Panno } = this.state
        const { hallID } = this.state
        var panErrMsg = panNoValidator(Panno)
        // var StateErrMsg = StateNoValidator(StateNo)
        if (countryID != null && countryID != '' && cityName != null && cityName != '' && StateID != null && StateID != '') {
            this.setState({ isLoading: true })
            this.props.insertCityMaster_action(countryID, StateID, cityName)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data)
                        this.props.navigate('/cityMasterList',)
                        toastSuccess("added successfully")
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })

        }
        else {
            toastError("Please enter mandatory fields")
        }
    }

    updateCityMaster() {
        const { isLoading, exhibitionID, StateID, StateErrMsg, countryID, CityID, cityName, StateNo, Panno, hallName, is_update } = this.state
        // var StateErrMsg = StateNoValidator(StateNo)
        if (countryID != null && countryID != '' && cityName != null && cityName != '' && StateID != null && StateID != '' && CityID != null && CityID != '') {
            this.setState({ isLoading: true })
            this.props.updateCityMaster_action(countryID, StateID, CityID, cityName)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data)
                        this.props.navigate('/cityMasterList',)
                        toastSuccess("update successful")
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        else {
            toastError("Please enter mandatory fields")
        }
    }

    onNextClick() {
        const { is_update } = this.state;
        if (is_update == true) {
            this.updateCityMaster();
        } else {
            this.insertCityMaster();
        }
    }

    render() {
        const { isLoading, exhibitionID, currentPage, countryID, StateID, stateList, StateNo, cityName, countryList, Panno } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <p className="mb-0 p-2 text-white">{this.state.is_add == true ? 'City Master Add' : 'City Master Update'}</p>
                            </div>
                        </div>
                        <div className="admin-top-space p-2">
                            {
                                JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                <div className="row m-0">
                                    <div className="col-md-3">
                                        <label>Country<span className="text-red">*</span></label>
                                        <select className="form-control"
                                            value={countryID}
                                            onChange={(e) => this.setState({ countryID: e.target.value })}  >
                                            <option value={''}>Select</option>
                                            {
                                                countryList.length > 0 && countryList.map(data => (
                                                    <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>State<span className="text-red">*</span></label>
                                        <select className="form-control"
                                            value={StateID}
                                            onChange={(e) => this.setState({ StateID: e.target.value })}  >
                                            <option value={''}>Select</option>
                                            {
                                                stateList.length > 0 && stateList.map(data => (
                                                    <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>City Name<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={cityName}
                                            onChange={(e) => this.setState({ cityName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label></label>
                                        {
                                            sessionStorage.getItem("sessionExhRegistrationID") == null &&
                                            <button className="btn btn-gray mt-2" onClick={e => this.onPreviousClick()}>
                                                {" "}
                                                Back{" "}
                                            </button>
                                        }

                                        <button className="btn btn-aqua mt-2 py-1 ms-2 2" onClick={e => this.onNextClick()} >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            }
                            < div className="row mt-3" >

                            </div>

                        </div>
                    </div>
                </>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, insertCityMaster_action, updateCityMaster_action, getCityMasterList_action })(StateAU));